<sd-component-wrapper>
  <div class="cgv-template" sd-component-wrapper-component>
    <wc-navigation-paragraph />
    <cx-page-slot position="DynamicBody" />
    <cx-page-slot position="SEO" />
  </div>
</sd-component-wrapper>
